import React, { Component } from "react";
import { connect } from "react-redux";
import {
    selectActiveProject,
    selectBasemap,
} from "../../reducers";
import PropTypes from "prop-types";
import { getPin, getIcon } from "../../modules/fund";
import { projectShape } from "../../modules/project";
import { setActiveProject, setIsMultiple } from "../../actions/ui";
import styles from "./project-popup.module.scss";
import { StaticMap, Marker } from "react-map-gl";
import streetsMapStyle from "../map/streets-map-style.json";
import satteliteMapStyle from "../map/sattelite-map-style.json";
import queryString from "query-string";

const MARKER_STYLE = {
    width: 24,
    height: 32,
    transform: "translate(-50%, -100%)",
}
const MARKER_STYLE_MULTIPLE = {
    width: 32,
    height: 48,
    transform: "translate(-50%, -100%)",
}

class ProjectPopup extends Component {
    render() {
        const { activeProject, setActiveProject, setIsMultiple, basemap } = this.props;
        if (!activeProject) return null;

        const query = queryString.parse(window.location.search);
        const fundingLabel =
            query.sheetName ?
                query.sheetName.includes("regional-recovery-map")
                    ? `Total funding:`
                    : `Total NSW funding:`
                : `Total NSW funding:`


        return (
            <div
                onClick={() => setActiveProject(null)}
                className={styles.overlay}
            >
                <div
                    onClick={(e) => e.stopPropagation()}
                    className={styles.projectPopup}
                >
                    <div className={styles.iconAndName}>
                        <img
                            className={styles.markerIcon}
                            src={getIcon(activeProject.fundName)}
                            alt={`Marker icon for: ${activeProject.fundName}`}
                        />{" "}
                        <h3>{activeProject.fundName}</h3>
                    </div>
                    <button
                        autoFocus
                        className={styles.closeButton}
                        onClick={() => setActiveProject(null)}
                    >
                        <img src="/img/cross.svg" alt="Cross" />
                    </button>
                    <h4>{activeProject["Project"]}</h4>
                    <p>{activeProject["Description"]} </p>
                    {activeProject["Total NSW funding"] && (
                        <p>
                            <label>{fundingLabel}</label>
                            <span>
                                {activeProject[
                                    "Total NSW funding"
                                ].toLocaleString()}
                            </span>
                        </p>
                    )}
                    {activeProject["Funding co-contribution"] && (
                        <p>
                            <label>Funding co-contribution:</label>
                            <span>
                                {(isNaN(
                                    activeProject["Funding co-contribution"]
                                )
                                    ? ""
                                    : "$") +
                                    activeProject[
                                        "Funding co-contribution"
                                    ]}{" "}
                            </span>
                        </p>
                    )}
                    {activeProject["Status"] && (
                        <p>
                            <label>Status:</label>
                            <span>{activeProject["Status"]}</span>
                        </p>
                    )}
                    <p>
                        <label>LGA:</label>
                        <span>{activeProject["LGA"]}</span>
                    </p>
                    {activeProject["Event dates"] && (
                        <p>
                            <label>Event date(s):</label>
                            <span>{activeProject["Event dates"]}</span>
                        </p>
                    )}
                    {activeProject["Multiple locations"] === "Y" && (
                        <p>
                            <label>Project is in multiple locations</label>
                            <span className={styles.multipleProjects}>Project locations are a central point within the Local Government Area and not necessarily the actual delivery location of the project.</span>
                        </p>
                    )}
                    {activeProject["Multiple locations"] === "Y" && activeProject["Multiple LGAs"] === "Y" && (
                        <button
                            className={styles.multipleButton}
                            onClick={e => setIsMultiple(activeProject)}>
                            View all project locations &#x203A;
                        </button>
                    )}
                    {activeProject["Round"] && (
                        <p>
                            <label>Round:</label>
                            <span>{activeProject["Round"]}</span>
                        </p>
                    )}
                    
                    
                    <StaticMap
                        mapboxApiAccessToken={
                            process.env.REACT_APP_MAPBOX_API_TOKEN
                        }
                        width={"100%"}
                        height={200}
                        zoom={10}
                        mapStyle={
                            basemap === "ROADMAP"
                                ? streetsMapStyle
                                : satteliteMapStyle
                        }
                        longitude={parseFloat(activeProject.Longitude)}
                        latitude={parseFloat(activeProject.Latitude)}
                    >
                        <Marker
                            longitude={parseFloat(activeProject.Longitude)}
                            latitude={parseFloat(activeProject.Latitude)}
                        >
                            <img
                                style={activeProject["Multiple locations"] === "Y"
                                    ? MARKER_STYLE_MULTIPLE
                                    : MARKER_STYLE
                                }
                                alt="pin"
                                src={activeProject["Multiple locations"] === "Y"
                                    ? "img-multiple" + getPin(activeProject.fundName)
                                    : getPin(activeProject.fundName)
                                }
                            />
                        </Marker>
                    </StaticMap>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (s) => ({
    activeProject: selectActiveProject(s),
    basemap: selectBasemap(s),
});
const mapDispatchToProps = {
    setActiveProject,
    setIsMultiple
};
ProjectPopup.propTypes = {
    activeProject: PropTypes.shape(projectShape),
    setIsMultiple: PropTypes.func.isRequired,
    setActiveProject: PropTypes.func.isRequired,
    basemap: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectPopup);



// WEBPACK FOOTER //
// ./src/components/project-popup/project-popup.js